// extracted by mini-css-extract-plugin
export var closeButton = "_1i-1";
export var container = "_1i-0";
export var fullModalImage = "_1i-2";